import useDuctedRailSections from 'components/equipment-page/use-ducted-rail-sections';
import { useMemo } from 'react';
import { DuctedSwapCandidates } from 'utils/ducted-component-swap-types';
import {
  isDuctedRailSectionLoading,
  listSettledSectionSelections
} from 'utils/ducted-rail-selections';

const NO_DUCTED_SWAP_CANDIDATES: DuctedSwapCandidates = {
  candidates: [],
  isLoading: false
};

export default function useDuctedSectionSwapCandidates(
  existingSystemUniqueId: string | null
): DuctedSwapCandidates {
  const { sections } = useDuctedRailSections();

  return useMemo(() => {
    if (existingSystemUniqueId === null) return NO_DUCTED_SWAP_CANDIDATES;
    const section = sections.find(
      (candidate) => candidate.system.uniqueId === existingSystemUniqueId
    );
    if (!section) return NO_DUCTED_SWAP_CANDIDATES;
    return {
      candidates: listSettledSectionSelections(section),
      isLoading: isDuctedRailSectionLoading(section)
    };
  }, [sections, existingSystemUniqueId]);
}
